import { SubHeadline, Text } from '~components/Typography';
import type { TMedia } from '~constants/media';
import { ImageRenderer } from '~shared/ui/molecules';
import { backgroundFromLetter } from '~shared/utils/backgroundFromLetter';

import { Author, AuthorAvatar, AuthorInfo, avatarImage } from './styles';

export type Props = {
	children: React.ReactNode;
	avatar?: TMedia[];
	name?: string;
	about?: React.ReactNode;
};

export const ProfileCardAuthor = ({ children, avatar, name, about }: Props) => {
	const [backgroundColor, letter] = backgroundFromLetter(name);

	return (
		<Author>
			<AuthorAvatar style={{ backgroundColor }}>
				{avatar?.length ? (
					<ImageRenderer
						className={avatarImage}
						item={avatar}
						width={48}
						height={48}
						alt={name ?? ''}
						fallback=""
					/>
				) : (
					<span>{letter}</span>
				)}
			</AuthorAvatar>
			<AuthorInfo>
				{name && (
					<SubHeadline size="M" as="h4" align="left">
						{name}
					</SubHeadline>
				)}
				{about && (
					<Text size="M" color="semi-transparent" align="left">
						{about}
					</Text>
				)}
			</AuthorInfo>
			<div>{children}</div>
		</Author>
	);
};
